import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: '#333333',
    marginBottom: theme.spacing(0.5),
  },
  sectionDescription: {
    fontSize: 13,
    color: '#6A6A6A',
    marginBottom: theme.spacing(2),
  },
  errorText: {
    color: '#D32F2F',
    fontSize: 13,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 1.5),
    backgroundColor: '#FFF5F5',
    borderRadius: 4,
    border: '1px solid #FFCDD2',
  },
  mediaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: theme.spacing(1.5),
    },
  },
  mediaItem: {
    position: 'relative',
    aspectRatio: '1',
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: '#F5F5F5',
    cursor: 'pointer',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      transform: 'scale(1.02)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    '&:hover $removeButton': {
      opacity: 1,
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: 8,
    },
  },
  mediaImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  videoThumbnail: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  videoPlaceholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1a1a2e',
  },
  videoPlaceholderIcon: {
    fontSize: 40,
    color: '#6A6A6A',
  },
  playOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    transition: 'background-color 0.2s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
  playIcon: {
    fontSize: 48,
    color: '#FFFFFF',
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))',
    [theme.breakpoints.down('sm')]: {
      fontSize: 36,
    },
  },
  removeButton: {
    position: 'absolute',
    top: 6,
    right: 6,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    opacity: 0,
    transition: 'opacity 0.2s ease, background-color 0.2s ease',
    padding: 6,
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#D32F2F',
    },
    [theme.breakpoints.down('sm')]: {
      opacity: 1,
    },
  },
  addMediaButton: {
    aspectRatio: '1',
    border: '2px dashed #D0D0D0',
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition:
      'border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease',
    backgroundColor: '#FAFAFA',
    minHeight: 120,
    '&:hover': {
      borderColor: '#00234B',
      backgroundColor: '#F0F4F8',
      transform: 'scale(1.02)',
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: 8,
      minHeight: 100,
    },
  },
  addMediaIcons: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  addMediaIcon: {
    color: '#6A6A6A',
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  addMediaText: {
    fontSize: 11,
    fontWeight: 700,
    color: '#00234B',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  addMediaHint: {
    fontSize: 10,
    color: '#9E9E9E',
    marginTop: 2,
  },
  uploadProgress: {
    color: '#00234B',
  },
  mediaLimits: {
    fontSize: 12,
    color: '#9E9E9E',
    textAlign: 'right',
  },
  // Video Dialog
  videoDialog: {
    backgroundColor: '#000000',
    borderRadius: 12,
    overflow: 'hidden',
    maxHeight: '90vh',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2),
      maxWidth: 'calc(100% - 32px)',
    },
  },
  videoDialogContent: {
    padding: '0 !important',
    backgroundColor: '#000000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 300,
  },
  closeDialogButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: 10,
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
  // Image Dialog
  imageDialog: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    maxWidth: '95vw',
    maxHeight: '95vh',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
    },
  },
  imageDialogContent: {
    padding: '0 !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '90vh',
    objectFit: 'contain',
    borderRadius: 8,
  },
}))

export default useStyles
